import { getDefaultState } from './default'

const state = getDefaultState()

const getters = {
  routes: state => {
    return state.routes
  }
}

export {
  state,
  getters
}
